/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_PhonesInputs */

const vi_shop_home_phones = /** @type {(inputs: Shop_Home_PhonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại`)
};

/**

* @param {Shop_Home_PhonesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_phones = /** @type {((inputs?: Shop_Home_PhonesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_PhonesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_phones(inputs)
});